(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[882],{

/***/ 9451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos",
      function () {
        return __webpack_require__(2709);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ UseTerms; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_layout_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9432);
/* harmony import */ var _components_layout_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(392);




function UseTerms(param) {
    let { companyGeneralData  } = param;
    companyGeneralData = JSON.parse(companyGeneralData);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Revenda de ve\xedculos multimarcas, novos e semi-novos. Ve\xedculos com proced\xeancia e garantia."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "https://bndv.com.br"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "".concat(companyGeneralData.company.nickName.toUpperCase(), " - ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", " - Termo de Uso")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "main-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_header__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        company: companyGeneralData.company
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "sr-service-section ptb-120",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "row justify-content-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xl-6 col-lg-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sr-section-title text-center mb-5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "h3 mb-4",
                                                children: "Termos de Uso e Pol\xedtica de Privacidade"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Bem-vindo ao nosso website. Ao acessar e usar nosso site, voc\xea concorda com os seguintes termos de uso e pol\xedtica de privacidade. Por favor, leia atentamente as seguintes informa\xe7\xf5es."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Uso do Site"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Nosso site \xe9 fornecido como est\xe1 e n\xf3s n\xe3o fazemos representa\xe7\xf5es ou garantias de qualquer tipo, expressas ou impl\xedcitas, sobre a completude, precis\xe3o, confiabilidade, adequa\xe7\xe3o ou disponibilidade com rela\xe7\xe3o ao site ou \xe0 informa\xe7\xe3o, produtos, servi\xe7os ou gr\xe1ficos relacionados inclu\xeddos no site para qualquer finalidade. Qualquer depend\xeancia que voc\xea coloque sobre tais informa\xe7\xf5es \xe9, portanto, por sua conta e risco."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Em nenhuma circunst\xe2ncia, incluindo, mas n\xe3o limitado a neglig\xeancia, seremos respons\xe1veis por quaisquer danos diretos, indiretos, incidentais, especiais, exemplares ou consequentes decorrentes do uso ou da impossibilidade de uso do nosso site."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Pol\xedtica de Privacidade"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "A privacidade de seus dados \xe9 muito importante para n\xf3s e tomamos medidas razo\xe1veis para proteg\xea-la. Neste documento, explicamos como coletamos, armazenamos e usamos as informa\xe7\xf5es pessoais que voc\xea fornece ao usar nosso site."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Informa\xe7\xf5es pessoais"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Coletamos informa\xe7\xf5es pessoais, tais como nome, endere\xe7o de e-mail, endere\xe7o postal e n\xfamero de telefone, quando voc\xea se registra em nosso site ou faz uma compra. Estas informa\xe7\xf5es s\xe3o usadas apenas para fornecer o melhor atendimento ao cliente e entrega de produtos."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Cookies"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "O uso de cookies \xe9 uma pr\xe1tica comum em websites. Eles nos permitem personalizar sua experi\xeancia de navega\xe7\xe3o e fornecer uma melhor compreens\xe3o de como voc\xea usa nosso site. Voc\xea pode escolher desativar os cookies no seu navegador, mas isso pode prejudicar sua capacidade de usar plenamente todos os recursos do nosso site."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Lei Geral de Prote\xe7\xe3o de Dados (LGPD)"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "N\xf3s cumprimos a Lei Geral de Prote\xe7\xe3o de Dados (LGPD), que regulamenta a coleta, armazenamento e uso de dados pessoais no Brasil. Isso inclui a prote\xe7\xe3o de suas informa\xe7\xf5es pessoais e o direito de acesso, corre\xe7\xe3o e exclus\xe3o de seus dados pessoais. N\xf3s tamb\xe9m tomaremos medidas razo\xe1veis para garantir a seguran\xe7a de seus dados pessoais e notificaremos voc\xea em caso de qualquer viola\xe7\xe3o de seguran\xe7a conhecida."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Permiss\xe3o de uso de dados"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Ao fornecer informa\xe7\xf5es pessoais ao usar nosso site, voc\xea concorda em nos permitir coletar, armazenar e usar essas informa\xe7\xf5es de acordo com esta pol\xedtica de privacidade. Se voc\xea optar por n\xe3o fornecer informa\xe7\xf5es pessoais, poder\xe1 ser impedido de usar algumas das funcionalidades do nosso site."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Altera\xe7\xf5es na Pol\xedtica de Privacidade"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-4",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Reservamo-nos o direito de modificar esta pol\xedtica de privacidade a qualquer momento. Qualquer altera\xe7\xe3o na pol\xedtica de privacidade ser\xe1 publicada em nosso site. \xc9 de sua responsabilidade verificar regularmente a pol\xedtica de privacidade para garantir que voc\xea esteja ciente das \xfaltimas altera\xe7\xf5es."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    fontWeight: "bold",
                                                    textAlign: "left"
                                                },
                                                children: "Contato"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "mb-5",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: [
                                                    "Se voc\xea tiver alguma d\xfavida sobre nossa pol\xedtica de privacidade ou precisar acessar, corrigir ou excluir seus dados pessoais, entre em contato conosco pelo nosso formul\xe1rio de contato clicando ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/contato",
                                                        children: "aqui"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                style: {
                                                    textAlign: "justify"
                                                },
                                                children: "Estes termos de uso e pol\xedtica de privacidade s\xe3o regidos e interpretados de acordo com as leis brasileiras. Qualquer disputa resultante destes termos de uso e pol\xedtica de privacidade ser\xe1 resolvida de acordo com a legisla\xe7\xe3o brasileira."
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        company: companyGeneralData.company
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,822,774,888,179], function() { return __webpack_exec__(9451); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);